<template>
  <div>
    <v-toolbar color="primary" dark>
        <v-toolbar-title>Seleccione Máquina</v-toolbar-title>
      </v-toolbar>
    <v-card>
      
      <v-tabs
        color="primary">
        <v-tab v-for="item in maquinas" :key="item.id" @click="cargarMaquina(item.tipo_equipo)">
          <!-- <img :src="require(`@/assets/img/${item.src}`)" alt="" class="responsive"> -->
          <img :src="getUrl(item.imagen)" alt="" class="responsive">
        </v-tab>
      </v-tabs>

    </v-card>

    <v-row class="ml-1 mr-1">
      <v-col>
        <v-select
          :items="lineas"
          item-text="label"
          item-value="id"
          v-model="linea_seleccionada"
          label="Seleccione Línea"
          dense
          solo
        ></v-select>
      </v-col>
      <v-col>
        <date-picker v-model="fecha" @change="cargarDatosGrafico" format="DD-MM-YYYY" valueType="YYYY-MM-DD"></date-picker>
      </v-col>
    </v-row>

    <v-row class="ml-3">
      
    </v-row>

    <v-row>
      <v-col>
        <GChart
          type="ColumnChart"
          :data="chartData"
          :options="chartOptions"
          @ready="graficoListo"
        />
      </v-col>
    </v-row>

      <!-- <v-row>
          <v-col>
            <v-card>
              <v-toolbar color="primary" dark>
                  <v-toolbar-title>Seleccione Máquina</v-toolbar-title>
                </v-toolbar>

                <v-tabs vertical color="#004D40">
                  <v-tab>
                    <img src="@/assets/img/cocedor.png" alt="" class="responsive">
                  </v-tab>
                  <v-tab>
                    <img src="@/assets/img/prensa.png" alt="" class="responsive">
                  </v-tab>
                  <v-tab>
                    <v-icon left>mdi-access-point</v-icon>
                    Option 3
                  </v-tab>

                  <v-tab-item>
                    <v-row class="ml-3">
                      <v-col>
                          <date-picker v-model="fecha" @change="cargarDatosGrafico" format="DD-MM-YYYY" valueType="YYYY-MM-DD"></date-picker>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <GChart
                                type="ColumnChart"
                                :data="chartData"
                                :options="chartOptions"
                                @ready="graficoListo"
                          />
                      </v-col>
                    </v-row>
                          
                  </v-tab-item>

                  <v-tab-item>
                    <v-card flat>
                      <v-card-text>
                        2
                      </v-card-text>
                    </v-card>
                  </v-tab-item>

                  <v-tab-item>
                    <v-card flat>
                      <v-card-text>
                        3
                      </v-card-text>
                    </v-card>
                  </v-tab-item>

            </v-tabs>
            </v-card>
                
          </v-col>
      </v-row> -->
  </div>
</template>
<script>
import { GChart } from 'vue-google-charts';
import { mapState } from 'vuex';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
export default {
    data:()=>({
        columnas:[],
        fecha:'',
        chartData: [],
        chartOptions: {
                title: 'Gráfico de TVN Cocedor',
                subtitle: '',
                legend: 'bottom',
                pointSize: 3,
                intervals: { style: 'bars' },
                bar: { groupWidth: '50%' },
                vAxis: {title: 'Valor medición', titleTextStyle: {color: '#000'}},
                // colors: ['#4DD0E1'],
                curveType: 'function',
                // isStacked: true,
        },
        maquina_actual:'',
        tipo_equipos:[],
        // maquinas:[
        //   {key:'cocedor',src:'cocedor.png'},
        //   {key:'prensa',src:'prensa.png'},
        // ],
        lineas:[
          {id:1,label:'Línea 1'},
          {id:2,label:'Línea 2'},
        ],
        linea_seleccionada:1,
        parametros_equipo:[]
    }),
    mounted() {
        this.fecha = this.moment().format('YYYY-MM-DD');
        console.log('fecha',this.fecha);
        this.cargarTipoEquipos();
        this.cargarDatosGrafico();
    },
    methods: {
        graficoListo(chart, google) {
            // var data = google.visualization.arrayToDataTable([
            //     ['Categegories', {label: 'Hora 00:00', type: 'number'} , {label: '01:00', type: 'number'} , {label: '02:00', type: 'number'} , {label: '03:00', type: 'number'} , {label: '04:00', type: 'number'} , {label: '05:00', type: 'number'} ],

            //     ['22-04-2020', 1, 4, 2, 4, 1,null],

            //     ['23-04-2020', 3, null,null,7, null,1],

            //     ['24-04-2020', null, null, null,8, null,null],
            //     ['22-04-2020', 1, 4, 2, 4, 1,null],
            //     ['22-04-2020', 1, 4, 2, 4, 1,null],
            //     ['22-04-2020', 1, 4, 2, 4, 1,null],
            //     ['22-04-2020', 1, 4, 2, 4, 1,null],
            //     ['22-04-2020', 1, 4, 2, 4, 1,null],


            // ]);
            // var data = new google.visualization.DataTable();
            // data.addColumn('string', 'Name');
            // data.addColumn('number', 'Salary');
            // data.addColumn('boolean', 'Full Time Employee');
            // data.addRows([
            // ['Mike',  {label: 'Return', type: 'number'}, true],
            // ['Jim',   8000,  false],
            // ['Alice', 12500, true],
            // ['Bob',  7000,  true]
            // ]);
            // this.chartData = data;
            this.chartData.push(['hora',{label: 'Valor', type: 'number'}]);
        },

        async cargarDatosGrafico(){
            let url = `${this.base_url}parametro_detalles/9/fecha/${this.fecha}`;
            await this.axios.get(url,this.headers).then((res)=>{
                this.chartData = [];
                console.log('respuesta',res);
                this.chartData.push(['hora',{label: 'Valor medición', type: 'number'}]);
                res.data.data.forEach(item => {
                    // this.columnas.push(this.moment(item.fecha).format('HH:mm'))
                    this.chartData.push([this.moment(item.fecha).format('HH:mm'),parseFloat(item.valor)])
                });
                // this.chartData.push(this.columnas);
                console.log('columnas',this.columnas);
            }).catch((error)=>{
                console.log('error',error);
            })
        },

        cargarMaquina(key){
          this.maquina_actual = key;
          if(key=='cocedor'){
            
          }
          console.log('cargar maquina',key);
        },

        async cargarUltimos3(){
          let url = `${this.base_url}linea/${this.linea_seleccionada}/tipo_equipo/${this.maquina_actual}`;
          await this.axios.get(url,this.headers).then((res)=>{
            console.log('respuesta',res.data.data);
          }).catch((error)=>{
            console.log('error',error);
          });
        },

        async cargarTipoEquipos(){
          let url = `${this.base_url}tipo_equipos`;
          await this.axios.get(url,this.headers).then((res)=>{
            console.log('tipo equipos',res);
            this.tipo_equipos = res.data.data;
          }).catch((error)=>{
            console.log('error',error);
          });
        },

        getUrl(imagen){
          let url = this.base_url.replace("/api/", "/");
          return `${url}archivos/imagenes/tipo_equipos/${imagen}`;
        }
    },
    computed: {

        maquinas(){
          let maq = [];
          this.tipo_equipos.forEach(t_p => {
            if(t_p.imagen){
              maq.push(t_p);
            }
          });
          return maq;
        },
        ...mapState(['base_url','headers'])
    },
    components:{
        GChart,
        DatePicker
    }
}
</script>
<style scoped>
.responsive {
  width: 100%;
  max-width: 150px;
  height: auto;
}

/* .alto{
    height: 100px !important;
} */
.v-tabs--vertical > .v-tabs-bar .v-tab{
    height: 100px;
}

.v-tab--active::before {
    opacity: 0.12 !important;
}
</style>